import type { LazyModuleDefinition } from "@/types";

export async function loader(modules: Array<LazyModuleDefinition>)
{
    for (const module of modules) {

        if (module?.id && window?._disableLazyModules?.includes?.(module?.id)) {
            console.info(`NOTE: Module ${module?.id} is disabled`);
            continue;
        }

        let shouldLoad: boolean = false;
        let evaluateResult: ReturnType<NonNullable<LazyModuleDefinition['evaluate']>> = null;

        if (!shouldLoad && module?.selectors?.length) {
            for (const selector of module.selectors) {
                const element = document.querySelector(selector);
                if (element) {
                    shouldLoad = true;
                    evaluateResult = module.selectors.map((selector: string) => {
                        return document.querySelector(selector);
                    });
                    break;
                }
            }
        }

        if (!shouldLoad) {
            evaluateResult = module?.evaluate?.();
        }

        if (!shouldLoad && evaluateResult !== false && evaluateResult !== undefined) {
            shouldLoad = true;
        }

        if (module?.smallScreensOnly && window.innerWidth > 768) {
            shouldLoad = false;
        }

        if (shouldLoad) {

            module?.pre?.(evaluateResult);

            if (module?.import) {
                const moduleResult = await module.import();
                new moduleResult.default(evaluateResult);
            }

            module?.post?.(evaluateResult);

            if (module?.id) {
                document.dispatchEvent(new CustomEvent('sitesmart:moduleloaded', {
                    detail: {
                        id: module.id,
                        timestamp: Date.now(),
                    },
                }));
            }
        }
    }
}
